import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetItemsPayload } from 'Types/getItemsPayload'
import { ResponseCatalog, RequestParams } from 'Models'
import { ADVERTISEMENT_TAB } from 'Pages/advertisement/constants'
import { Callback } from 'Src/types/utilTypes'
import {
	DictsListModel,
	OrganizationCreateModel,
	OrganizationModel,
} from 'Pages/advertisement/models'

export type OrganizationState = {
	org_list: ResponseCatalog<OrganizationModel>
	requestParams: RequestParams
	org: OrganizationCreateModel | null
	dict: DictsListModel
	openedOrg: number
	activeTab: ADVERTISEMENT_TAB
}

export const organizationInitialState: OrganizationState = {
	org_list: new ResponseCatalog<OrganizationModel>(),
	requestParams: new RequestParams(),
	org: null,
	dict: new DictsListModel(),
	openedOrg: null,
	activeTab: ADVERTISEMENT_TAB.ORGANIZATION,
}

export namespace organizationNS {
	export type getOrganizationList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type getOrganizationListSelect = PayloadAction<GetItemsPayload>
	export type setOrganizationList = PayloadAction<ResponseCatalog<OrganizationModel>>
	export type setRequestParams = PayloadAction<RequestParams>
	export type GetOrganization = PayloadAction<number>
	export type SetOrganization = PayloadAction<OrganizationCreateModel>
	export type CreateOrganization = PayloadAction<OrganizationCreateModel>
	export type UpdateOrganization = PayloadAction<{
		id: string
		data: OrganizationCreateModel
	}>
	export type GetDict = PayloadAction
	export type SetDict = PayloadAction<DictsListModel>
	export type SetOrgOPened = PayloadAction<number>
	export type setActiveTab = PayloadAction<ADVERTISEMENT_TAB>

	export type ChangeOrgFromSocket = PayloadAction<{
		organization_id: number
		status: string
		external_id: string
		registered_at: string
	}>
	export type ToggleActivePlatform = PayloadAction<string>
}

export const organizationSlice = createSlice({
	name: 'organization',
	initialState: organizationInitialState,
	reducers: {
		getAll: (state, action: organizationNS.getOrganizationList) => {},
		getListSelect: (state, action: organizationNS.getOrganizationListSelect) => {},
		setAll: (state, action: organizationNS.setOrganizationList) => {
			state.org_list = action.payload
		},
		setRequestParams: (state, action: organizationNS.setRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.org_list = new ResponseCatalog<OrganizationModel>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: organizationNS.GetOrganization) => {},
		setOne: (state, action: organizationNS.SetOrganization) => {
			state.org = action.payload
		},
		createOne: (state, action: organizationNS.CreateOrganization) => {},
		updateOne: (state, action: organizationNS.UpdateOrganization) => {},
		getDict: () => {},
		setDict: (state, action: organizationNS.SetDict) => {
			state.dict = action.payload
		},
		setOpened: (state, action: organizationNS.SetOrgOPened) => {
			state.openedOrg = action.payload
		},
		setActiveTab: (state, action: organizationNS.setActiveTab) => {
			state.activeTab = action.payload
		},
		setToggleActivePlatform: (state, action: organizationNS.ToggleActivePlatform) => {},
		changeOrgFromSocket: (state, action: organizationNS.ChangeOrgFromSocket) => {
			const { organization_id } = action.payload
			const findOrgIndex = state.org_list.entries.findIndex((org) => org.id === organization_id)
			if (findOrgIndex) {
				state.org_list.entries[findOrgIndex] = {
					...state.org_list.entries[findOrgIndex],
					...action.payload,
				}
			}
		},
	},
})
